import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  constructor(private http: HttpClient) { }

  postCategory(formData){
    return this.http.post(environment.apiBaseURI + '/ProductCategory', formData)
  }

  putCategory(formData){
    return this.http.put(environment.apiBaseURI + '/ProductCategory/' + formData.id, formData)
  }

  getProductCategoryList(param: any){
    return this.http.post(environment.apiBaseURI + '/ProductCategory/GetProductCategoryDetailsList', param);
  }
  getProductCategories(){
    return this.http.get(environment.apiBaseURI + '/ProductCategory/');
  }

  deleteCategory(id) {
    return this.http.delete(environment.apiBaseURI + '/ProductCategory/' + id);
  }

}
